import { Component, ElementRef, ViewChild, Inject } from "@angular/core"
import { MatAutocomplete, MatDialog, MatCheckbox, MatChipInputEvent, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { ENTER, COMMA } from "@angular/cdk/keycodes";
import { FormGroup, FormArray, FormBuilder, Validators, FormControl } from "@angular/forms";
import { Subject } from "rxjs";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/app.reducer";
import { ActivatedRoute } from "@angular/router";
import { ClearTagAction, GetAllTagsListStartAction, AddTagStartAction, GetTaskDetails } from "src/app/features/home/tasks/store/tasks.actions";
import { take, debounceTime, distinctUntilChanged, takeUntil } from "rxjs/operators";
import { AddDocument } from "src/app/features/home/resources/_store/resources.actions";
import * as FilePond from "filepond";
import * as FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import { Location } from "@angular/common"
import { NotificationModalComponent } from "src/app/features/common-components/notification-modal/notification-modal.component";
import { CommonService } from "src/app/services/tasks.services";
import { MAX_ALLOWED_FILE_SIZE, ACCEPTED_FILE_TYPES, ACCEPTED_FILE_TYPES_TEXT, MIME_TYPE_ON_EXTENSION } from "src/app/app.constants";
import { LoaderShow } from 'src/app/features/loader/store/loader.actions';
import { ValidationUtil, VALIDATION_MESSAGES } from "../../utils/validation.util";
import { GetConfigurations } from "src/app/features/home/configurations/store/configurations.actions";
import { format } from "path";

@Component({
  selector: 'upload-document-dialog',
  templateUrl: './upload-document-dialog.component.html',
  styleUrls: ['./upload-document-dialog.component.scss']
})
export class UploadDocumentDialog {

  documentId;
  currentVersion;
  addNewVersion = false;
  existingThemes: Array<any> = [];
  form: FormGroup;
  themeList$;
  themesFormArray: FormArray;
  tagList$;
  stopper$: Subject<void> = new Subject<void>();
  fileName = '';
  showFilePond = true;
  isPublish = false;

  specialCharregex = new RegExp(/^[A-Za-z0-9 ]*[A-Za-z0-9][A-Za-z0-9 ]*$/);
  multiSpaceRegex = new RegExp(/\w*[ ]{2,}\w*$/);
  separatorKeysCodes: number[] = [ENTER, COMMA];
  error = false;
  inUploadDialogComponent: Boolean = true;
  maxFileSizeExceeded: boolean = false;
  regExError: boolean = false
  documentTypes = [{ name: "Main Document", key: "main-document" }, { name: "Annexures", key: "annexures" }, { name: "KML", key: "kml" }, { name: "Figures", key: "figures" }]
  @ViewChild('myPond', { static: false }) public myPond: any;
  @ViewChild('auto', { static: false }) matAutocomplete: MatAutocomplete;
  @ViewChild('tagInput', { static: false }) tagInput: ElementRef<HTMLInputElement>;

  pondOptions: any = {
    name: 'upfile',
    class: 'my-filepond',
    multiple: false,
    labelIdle: 'Drag or Upload File here',
    // maxFileSize: '1KB',
    allowFileSizeValidation: true,
    labelMaxFileSizeExceeded: 'File is too large',
    // labelMaxFileSize:'Maximum file size is 20MB'
    fileValidateTypeLabelExpectedTypes: ['Allowed file formats: {allTypes}'],
    acceptedFileTypes: ACCEPTED_FILE_TYPES,
    fileValidateTypeLabelExpectedTypesMap: ACCEPTED_FILE_TYPES_TEXT,
    fileValidateTypeDetectType: (source, type) => new Promise((resolve, reject) => {
      if (type === "") {
        let fileExtension = source.name.split('.').pop();
        resolve(MIME_TYPE_ON_EXTENSION(fileExtension));
      } else {
        resolve(type);
      }
    })
  };

  pondFiles: [];
  fileToUpload: any;
  isFileReplaced: boolean;
  uploadStarted = false;
  accessToken: any;
  userCapability: Array<string> = [];
  docDetail: any;
  addTag: boolean = false;
  // responseTags: any[] =[];
  selectedTags: any = [];
  selectedTagWithId: any;
  selectedTagIds: any = [];
  tagsList: any = [];
  removable = true;
  noFileName: boolean = false;
  updateCall: boolean = false;
  documentFormdata = new FormData()
  calledOnce: boolean = false;
  validationMsg = VALIDATION_MESSAGES;
  documentObj: any;
  MaxSizeAllowed: number = 0;
  hasErrorInFile: boolean;
  errorForFile: any;
  searchString;

  constructor(
    public location: Location,
    private fb: FormBuilder,
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<any>,
    private commonService: CommonService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.dialogRef.disableClose = true;
    this.form = this.fb.group({
      name: ['', Validators.compose([
        Validators.required,
        ValidationUtil.cannotBeBlank,
      ])],
      description: [''],
      tags: [''],
      summary: [''],
      type: ['']
    });
  }

  ngOnInit() {
    this.store.dispatch(new ClearTagAction());
    this.tagList$ = this.store.select(state => state.resources.tags);
    this.store.select(state => state.auth).pipe(take(1)).subscribe(auth => {
      this.accessToken = auth.accessToken;
    });

    /* check if edit mode */
    this.route.params.subscribe(params => {
      console.log(params, "params ")
      this.documentId = (params || {}).documentId;
      this.currentVersion = (params || {}).currentVersion;
      this.isPublish = ((params || {}).action || ' ').includes('publish');
    });

    FilePond.registerPlugin(FilePondPluginFileValidateSize);

    this.form.controls.tags.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe((value) => {

      this.searchString = value;


      this.error = false;
      this.regExError = false
      if (value != null) {
        (typeof (value) === 'number') ? value.toString() : value;
        let trimmedVal = value.trim();
        if (trimmedVal.length) {
          this.specialCharregex = new RegExp(/^[A-Za-z0-9 ]*[A-Za-z0-9][A-Za-z0-9 ]*$/);
          this.multiSpaceRegex = new RegExp(/[ ]{2,}/);

          if (this.specialCharregex.test(value)) {
            let value = trimmedVal.trim();
            this.store.dispatch(new GetAllTagsListStartAction({ 'search': value }))
          }
          else {
            this.tagsList = []
            this.error = false;
            this.regExError = true;
          }

          if (!this.multiSpaceRegex.test(value)) {
            let value = trimmedVal.trim();
            this.store.dispatch(new GetAllTagsListStartAction({ 'search': value }))
          }
          else {
            this.tagsList = []
            this.regExError = false;
            this.error = true;
          }
        } else {
          this.tagsList = []
        }
      }
    })
    this.store.select(state => state.tasks.tagsList).subscribe((taglist) => {

      taglist.unshift({ tag: ` + Create tag for '${this.searchString}'` });


      this.tagsList = taglist.filter((tag) => !this.selectedTagIds.includes(tag._id));
      if (taglist.length) {
        this.addTag = false;
      } else {
        this.addTag = true;
      }
    });
    this.store.select(state => state.tasks.addedTag).subscribe((response) => {

      //check for response when added new tag
      if (this.commonService.componentForAddingTag === 'uploadDialog') {
        if (Object.keys(response).length) {
          if (this.inUploadDialogComponent) {
            let data = response;
            let index = this.selectedTags.findIndex(tag => tag === response.tag);
            if (index === -1) {
              this.selectedTags.push(response.tag);
              this.selectedTagIds.push(data._id);
              // this.store.dispatch(new ClearTagAction());
              this.tagsList = []
            }
          }
        }
      }
    })
    this.tagsList = []
    // effect for add document for tasks
    // this.action$.pipe(
    //   ofType(ResourcesActionTypes.ADD_DOCUMENT),
    //   switchMap((action: AddDocument) => {
    //     if(action.callType == 'fromTask') {

    //     return this.api.uploadNewDocument(action.payload).pipe(
    //       map((response: any) => {
    //         console.log(response, 'response')
    //         if(response && response._id) {
    //             this.notificationService.success(`Document created successfully.`);
    //             this.dialogRef.close(response);
    //               return of('')

    //         }
    //       })

    //     )
    //     }
    //     return of('')
    //   }
    //   )

    // ).subscribe()


    this.store.select(state => state.resources.document).subscribe((resp) => {
      console.log(resp);
    })
    this.store.select(state => state.resources.docAdded).subscribe((data) => {
      if (this.calledOnce) {
        if (data && Object.keys(data).length) {
          this.dialogRef.close(data)
        }
      } else {
        //do nothing
      }
    })
    this.store.dispatch(new GetConfigurations());
    this.store.select(state => state.configurations.configurations).pipe(takeUntil(this.stopper$)).subscribe((resp: any) => {
      if (Object.keys(resp).length) {
        this.documentObj = Object.assign({}, resp);

        this.documentObj['documentName'] = resp['docNameLength'].displayName;
        this.documentObj['documentNameLength'] = parseInt(resp['docNameLength'].value);
        this.documentObj['documentDescriptionSize'] = parseInt(resp['docDescriptionSize'].value);
        this.MaxSizeAllowed = parseInt(resp['docSize'].value) * 1024 * 1024;
        console.log(this.MaxSizeAllowed);
        this.pondOptions.maxFileSize = resp['docSize'].value + 'MB';
        this.pondOptions.labelMaxFileSize = `Maximum file size allowed is ${resp['docSize'].value}MB`;
        if (this.myPond) {
          this.myPond.pond.maxFileSize = this.MaxSizeAllowed;
          this.myPond.pond.labelMaxFileSize = `Maximum file size allowed is ${resp['docSize'].value} MB`;
        }

        let validators = [Validators.maxLength(parseInt(resp['docNameLength'].value))];
        let docNameValidator = [Validators.maxLength(parseInt(resp['docDescriptionSize'].value))]
        this.form.get('name').setValidators([Validators.required, ValidationUtil.cannotBeBlank,
        Validators.pattern('(.*)([a-zA-Z0-9])(.*)$'),
        ...validators]);
        this.form.get('description').setValidators([...docNameValidator]);

      }
    })
  }

  ngAfterViewInit() { }

  onThemeChange(checkbox: MatCheckbox, themeId: string) {
    if (checkbox.checked) {
      this.themesFormArray.push(new FormControl(themeId));
    } else {
      const index = this.themesFormArray.controls.findIndex(
        x => x.value === themeId
      );
      this.themesFormArray.removeAt(index);
    }
  }

  pondHandleInit() {
    console.log('FilePond has initialised', this.myPond);
  }

  pondHandleAddFile(event: any) {
    if (event.error) {
      this.hasErrorInFile = true;
      this.errorForFile = event.error.sub;
    } else {
      this.hasErrorInFile = false;
      this.errorForFile = '';
    }
    if (this.fileName) {
      this.isFileReplaced = true;
      this.noFileName = false;
    }
    if (event.file.file.size > this.MaxSizeAllowed) {
      this.maxFileSizeExceeded = true;
      this.noFileName = false;
    } else {
      this.maxFileSizeExceeded = false;
      this.fileToUpload = event.file.file;
      this.isFileReplaced = true
      this.noFileName = false
      this.showFilePond = true;
    }
  }

  pondFileRemoved(event: any) {
    this.hasErrorInFile = false;
    if (this.fileName) {
      this.isFileReplaced = false;
      this.showFilePond = false;
      this.noFileName = false;
    }
    this.fileName = '';
    this.noFileName = true;
    this.maxFileSizeExceeded = false;
  }

  doSubmit() {
    // check added to fix bug: Add new document without attaching any doc - is getting created. (CNW 664)
    if (this.hasErrorInFile) {
      return;
    }
    if (this.maxFileSizeExceeded) return;

    if (this.noFileName) {
      return false;
    }

    if (this.form.valid && this.isFileReplaced) {
      let formData = new FormData();
      if (!this.fileToUpload === undefined || typeof (this.fileToUpload) === 'object' || this.fileName.length) {
        this.noFileName = false;
      } else {
        this.noFileName = true
      }
      if (this.form.invalid) {
        return false;
      } /*  else if (!this.fileName) { TODO:: Check why this is needed.
          return false;
        } */
      const data = this.form.value;

      // } 

      // now call the api for documentId
      formData.append('upfile', this.fileToUpload);
      formData.append('docName', data.name);
      formData.append('tags', JSON.stringify(this.selectedTagIds || []));
      formData.append('description', data.description);
      formData.append('summaryObservations', data.summary);
      if (this.data && this.data.docType == 'contract') {
        formData.append('type', this.data.docType)
      }
      else {
        formData.append('type', data.type)
      }
      this.store.dispatch(new LoaderShow());
      this.store.dispatch(new AddDocument(formData, "fromTask"));
      this.calledOnce = true
    } else {
      this.noFileName = true;
      Object.keys(this.form.controls).forEach((controlField) => {
        const control = this.form.get(controlField);
        control.markAsTouched({ onlySelf: true })
      })
    }
    // new Response(this.formData).text().then(console.log)
    // this.api.uploadNewDocument(this.formData)
  }

  publishDocument(payload) {
    const dialogRef = this.dialog.open(NotificationModalComponent, {
      width: '40%',
      panelClass: 'cmp-modal',
      data: {
        text: 'Are you sure you want to publish this document?'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // this.store.dispatch(new PublishDocument(this.documentId, payload));
      }
    });
  }

  clickReplaceFile() {
    this.showFilePond = true;
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value.trim();

    this.addOnTagSubmit(value);

    if (input) {
      input.value = '';
    }
    this.form.controls.tags.setValue(null);
  }

  addOnTagSubmit(value) {
    if (!this.matAutocomplete.isOpen) {
      if (!this.error) {
        let index = this.selectedTags.findIndex((tag) => tag === value.trim());
        if (index === -1) {
          if (this.addTag) {
            this.commonService.componentForAddingTag = 'uploadDialog'
            this.store.dispatch(new LoaderShow());
            this.store.dispatch(new AddTagStartAction({ 'tag': value }));
            this.tagsList = []
          }
        }
      }
      // Reset the input value
    } else {
      let index = this.tagsList.findIndex((tag) => tag.tag === value);
      if (index === -1) {
        this.commonService.componentForAddingTag = 'uploadDialog'
        this.store.dispatch(new LoaderShow());
        this.store.dispatch(new AddTagStartAction({ 'tag': value }));
        this.tagsList = []
      } else {
        let index = this.selectedTags.findIndex((tag) => tag === value.trim());
        let tagData: any = this.tagsList.filter((tag) => tag.tag === value);
        if (index === -1) {
          this.selectedTags.push(tagData[0].tag);
          this.selectedTagIds.push(tagData[0]._id);
          this.tagsList = []
        }
      }
    }
  }

  selected(event) {
    let index = this.selectedTags.findIndex(tag => tag === event.option.value.tag);
    if (index === -1) {
      if (!event.option.value._id) {
        this.addOnTagSubmit(this.searchString);
      } else {
        this.selectedTags.push(event.option.value.tag);
        this.selectedTagIds.push(event.option.value._id)
      }
    }
    this.tagInput.nativeElement.value = '';
    this.form.controls.tags.setValue(null);
  }

  remove(tag) {
    const index = this.selectedTags.indexOf(tag);
    if (index >= 0) {
      this.selectedTags.splice(index, 1);
      this.selectedTagIds.splice(index, 1);
    }
  }

  onCancelClick() {
    this.selectedTags = [];
    this.selectedTagIds = [];
    this.dialogRef.close();
  }
}